﻿(function (document) {
    document.addEventListener("DOMContentLoaded", function () {

        var productShare = document.querySelector("[data-product-share]");

        if (productShare == null
        || typeof(productShare) == 'undefined' ) {
            return;
        }

        productShare.addEventListener("click", function () {
            var titleElement = document.getElementById('hdnShareTitle');
            var textElement = document.getElementById('hdnShareText');
            var productUrlElement = document.getElementById('hdnShareUrl');

            var title = titleElement ? titleElement.value : null;
            var text = textElement ? textElement.value : null;
            var productUrl = productUrlElement ? productUrlElement.value : null;

            var shareData = {};

            if (title) {
                shareData.title = title;
            }

            if (text) {
                shareData.text = text;
            } else if (productUrl) {
                shareData.url = productUrl;
            }

            if (navigator.canShare
                && navigator.canShare(shareData)
                && navigator.platform.indexOf('Win') == -1) {

                navigator.share(shareData)
                    .then(() => console.log('Share was successful.'))
                    .catch((error) => console.log('Sharing failed: ', error))
                ;

            } else {
                document.ShowModal(document.querySelector(".checkout-modal__container"));
            }


        });

    });
})(document);